import React from 'react';
import styled from '@emotion/styled';
import { LoadingIcon } from 'dw-us-ui';

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  background: #00000078;
`;

const Loader = () => {
  return (
    <LoaderContainer>
      <LoadingIcon />
    </LoaderContainer>
  );
};

export { Loader };
